<template>
  <div class="default-layout">
    <slot name="sidebar">
      <DefaultSidebar />
    </slot>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
import DefaultSidebar from "@/components/Sidebar/DefaultSidebar";

export default {
  name: "DefaultLayout",
  components: {
    DefaultSidebar,
  },
};
</script>

<style lang="scss">
.default-layout {
  width: 100%;
  & > .content {
    padding: 20px;
    padding-left: 90px;
  }
}

@media screen and (min-width: $breakpoint-tablet) {
  .default-layout {
    & > .content {
      padding: 30px 50px 0 110px;
    }
  }

  .sidebar-expanded .default-layout > .content {
    padding-left: 350px;
  }
}
</style>
